(($, Drupal) => {
  Drupal.behaviors.contacts = {
    attach: function attach() {
      $('.contacts__map').once('loadMap').each(function () {
        const { img } = this.dataset;
        const { text } = this.dataset;
        const position = {
          lat: 42.250278325047546, // this.dataset.lat,
          lng: 42.68698659507553, // this.dataset.lng
        };
        const link = {
          text: this.dataset.link,
          url: this.dataset.url,
        };


        function initMap() {
          const iconUrl = '/themes/custom/brander/html/src/assets/images/location.svg';

          const locations = [
            ['Starling branch, #10 Demetre Tavdadebuli Street, Batumi, Georgia', 41.650630477429004, 41.63420744854374, 5],
            ['Vazha Pshavela Avenue 4, Tbilisi, Georgia', 41.72734380978696, 44.767005207106735, 5],
            ['Isani - Starling Branch, #71 Queen Ketevan Avenue, Tbilisi, Georgia', 41.68769283818411, 44.83006936687615],
            ['Gldani - Starling branch, #5 Ilia Vekua Street, Tbilisi, Georgia', 41.79349080218614, 44.81212373721112, 5],
            ['Starling branch, #6 Ilia Chavchavadze Street, Kutaisi, Georgia', 42.250278325047546, 42.68698659507553, 5],
          ];

          const stylers = [{
            featureType: 'landscape.natural',
            stylers: [{
              color: '#f3f2f3',
            }],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [{
              color: '#f3f2f3',
            }],
          },
          {
            featureType: 'landscape.man_made.building',
            elementType: 'geometry.fill',
            stylers: [{
              color: '#f1f1f1',
            }],
          },
          {
            featureType: 'landscape.man_made.building',
            elementType: 'geometry.stroke',
            stylers: [{
              color: '#aeaead',
            }],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{
              color: '#f1f1f1',
            }],
          },
          {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [{
              color: '#aeaeae',
            }],
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [{
              color: '#aeaeae',
            }],
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.stroke',
            stylers: [{
              visibility: 'off',
            }],
          },
          {
            elementType: 'labels.text.fill',
            stylers: [{
              color: '#aeaeae',
            }],
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{
              color: '#ffffff',
            }],
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{
              color: '#cbcbcb',
            }],
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{
              color: '#e5e5e5',
            }],
          },
          ];

          const map = new google.maps.Map(
            document.getElementById('map'), {
              zoom: 8,
              center: new google.maps.LatLng(position.lat, position.lng),
              styles: stylers,
            },
          );

          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(position.lat, position.lng),
            icon: iconUrl,
            map,
          });

          let count;

          for (count = 0; count < locations.length; count++) {
            new google.maps.Marker({
              position: new google.maps.LatLng(locations[count][1], locations[count][2]),
              icon: iconUrl,
              map,
              title: locations[count][0],
            });
          }


          const windowContent = `
            <div class="map-popup">
              <div class="map-popup__img-wrap">
                <img class="map-popup__img" src="${img}" alt="picture" />
              </div>
              <div class="map-popup__content">
                <div class="map-popup__text">${text}</div>
                <a class="map-popup__link" href="${link.url}">${link.text}</a>
              </div>
            </div>
          `;

          const infowindow = new google.maps.InfoWindow({
            content: windowContent,
          });

          google.maps.event.addListener(marker, 'click', () => {
            infowindow.open(map, marker);
          });
        }

        initMap();
      });
      $('#tabs').tabs();
      // $( "div.contact-item_wrapper div.contact-item.country_item" ).off().one( "click", function() {
      //   console.log(this.id);
      //   $( '#'+this.id+' div.contact-item_dropdown').toggle();
      //   //event.stopImmediatePropagation();
      // });
    },
  };

  jQuery('.contact-item_title').click(function () {
    const $this = jQuery(this);
    const parent = $this.parents('.contact-item');

    parent.toggleClass('open').find('.contact-item_dropdown').slideToggle();
    jQuery('.contact-item').not(parent).removeClass('open').find('.contact-item_dropdown')
      .slideUp();
  });
})(jQuery, Drupal);
